import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './sign.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions"
import { ContractSign } from "model/contract/sign.model";

export interface ContractSignDetailsProps extends DetailsStateAndDispatchProps<ContractSign>,
  RouteComponentProps, StateProps, DispatchProps {
}
const ContractSignDetails: FC<ContractSignDetailsProps> = (props) => {
  return (
    <DetailsPage<ContractSign>
      title={'详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<ContractSign>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ contractSign }: RootState) => ({
  entity: contractSign.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(ContractSignDetails);
